
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authgate/outdatedlink",
      function () {
        return require("private-next-pages/authgate/outdatedlink/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authgate/outdatedlink"])
      });
    }
  